export const setMeta = (meta) => {
  const titleTemplate =
    "titleTemplate" in meta
      ? meta.titleTemplate || ""
      : " | auスマートパス";
  document.title = meta.title + titleTemplate;
};
